






































































































































import { IDialog } from "@/lib/interfaces/dialog.interface";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IAddress, Address } from "@/models/address.entity";
import { Company, ICompany } from "@/models/company.entity";
import { IInvoiceParty, InvoiceParty } from "@/models/invoice-party.entity";
import { IPerson, Person } from "@/models/person.entity";
import { IReference } from "@/models/reference.entity";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { CompanyModule } from "@/store/modules/company.store";
import { PersonModule } from "@/store/modules/person.store";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import CompanySideCard from "../company/CompanySideCard.vue";
import PersonSideCard from "../person/PersonSideCard.vue";
import RefsCompanyAddress from "../utility/RefsCompanyAddress.vue";
import RefsSelect from "../utility/RefsSelect.vue";
import RefsSelectForm from "../utility/RefsSelectForm.vue";

@Component({
  components: {
    RefsSelectForm,
    RefsSelect,
    RefsCompanyAddress,
    PersonSideCard,
    CompanySideCard
  },
  filters: {}
})
export default class InvoicePartyForm extends mixins(RulesMixin, PermissionMixin) implements IDialog {
  readonly getAutocompleteFilter = getAutocompleteFilter;

  @Prop()
  value!: IInvoiceParty;

  @Prop({ default: false })
  readonly!: boolean;

  @Prop({ default: false })
  isValid!: boolean;

  @Prop()
  partnerId!: string;

  @Prop()
  title!: string;

  get isCompany() {
    return this.value.ref?.refType === BackendResourceEnum.COMPANY;
  }

  open() {
    this.isMenuActive = true;
  }

  close() {
    this.isMenuActive = false;
  }

  isMenuActive = false;

  isSideCardActive = false;

  validity = {
    line1: true,
    line2: true,
    line3: true,
    name: true,
    email: true,
    phone: true,
    taxnumber: true
  };

  company: ICompany | null = null;

  person: IPerson | null = null;

  async mounted() {
    const ref = this.value.ref;
    if (ref?.refType === BackendResourceEnum.PERSON) {
      let person: IPerson | null = PersonModule.maps.id.get(ref.refId)[0];

      if (!person) {
        person = await new Person({ id: ref.refId, partnerId: this.partnerId }).fetch().catch(e => {
          this.$log.error(e);
          return null;
        });
      }

      this.person = person;
    } else if (ref?.refType === BackendResourceEnum.COMPANY) {
      let company: ICompany | null = CompanyModule.maps.id.get(ref.refId)[0];

      if (!company) {
        company = await new Company({ id: ref.refId, partnerId: this.partnerId }).fetch().catch(e => {
          this.$log.error(e);
          return null;
        });
      }

      this.company = company;
    }

    this.updateValidity();
  }

  private async buildInvoicePartyFromPersonRef(ref: IReference) {
    const invoiceParty = new InvoiceParty();
    if (ref.refType !== ResourceEnum.PERSON) {
      return;
    }
    let person: IPerson | null = PersonModule.maps.id.get(ref.refId)[0];
    if (!person) {
      person = await new Person({ id: ref.refId, partnerId: this.partnerId }).fetch().catch(e => {
        this.$log.error(e);
        return null;
      });
    }
    if (!person) {
      return { invoiceParty: null, person: null };
    }

    invoiceParty.name = "";
    if (person.firstName) {
      invoiceParty.name = person.firstName;
    }
    if (person.lastName) {
      if (invoiceParty.name) {
        invoiceParty.name += " ";
      }
      invoiceParty.name += person.lastName;
    }
    if (person.emails?.length) {
      invoiceParty.email = person.emails[0].email;
    } else {
      invoiceParty.email = undefined;
    }
    if (person.phones?.length) {
      invoiceParty.phone = person.phones[0].phone;
    } else {
      invoiceParty.phone = undefined;
    }
    if (person.addresses?.length) {
      invoiceParty.address = new Address(person.addresses[0]);
    }

    return { invoiceParty, person };
  }

  private async buildInvoicePartyFromCompanyRef(ref: IReference) {
    const invoiceParty = new InvoiceParty();
    if (ref.refType !== ResourceEnum.COMPANY) {
      return;
    }

    let company: ICompany | null = CompanyModule.maps.id.get(ref.refId)[0];
    if (!company) {
      company = await new Company({ id: ref.refId, partnerId: this.partnerId }).fetch().catch(e => {
        this.$log.error(e);
        return null;
      });
    }
    if (!company) {
      return { invoiceParty: null, company: null };
    }

    invoiceParty.name = "";
    if (company.firstName) {
      invoiceParty.name = company.firstName;
    }
    if (company.lastName) {
      if (invoiceParty.name) {
        invoiceParty.name += " ";
      }
      invoiceParty.name += company.lastName;
    }
    if (company.company) {
      if (invoiceParty.name) {
        invoiceParty.name += " ";
      }
      invoiceParty.name += company.company;
    }

    invoiceParty.email = company.contact?.email;
    invoiceParty.phone = company.contact?.phone;

    if (company.billingAddress) {
      invoiceParty.address = new Address(company.billingAddress);
    }

    invoiceParty.taxnumber = company.taxnumber;

    return { invoiceParty, company };
  }

  async buildInvoicePartyFromCompanyOrPersonRef(refs: IReference[]) {
    const ref = refs[0];
    if (!ref) {
      return {
        invoiceParty: null,
        person: null,
        company: null
      };
    }

    let person: IPerson | null = null;
    let company: ICompany | null = null;
    let invoiceParty: IInvoiceParty | null = null;

    if (ref?.refType === ResourceEnum.PERSON) {
      const res = await this.buildInvoicePartyFromPersonRef(ref);
      invoiceParty = res?.invoiceParty ?? null;
      person = res?.person ?? null;
    } else if (ref?.refType === ResourceEnum.COMPANY) {
      const res = await this.buildInvoicePartyFromCompanyRef(ref);
      invoiceParty = res?.invoiceParty ?? null;
      company = res?.company ?? null;
    }

    if (invoiceParty) {
      invoiceParty.ref = ref;
    }

    return {
      invoiceParty,
      person,
      company
    };
  }

  async setInvoicePartyFromCompanyOrPersonRef(refs: IReference[]) {
    const { person, company, invoiceParty } = await this.buildInvoicePartyFromCompanyOrPersonRef(refs);

    this.person = person;
    this.company = company;
    this.value.map(invoiceParty ?? new InvoiceParty());
    this.isMenuActive = false;
  }

  @Watch("value.ref")
  @Watch("validity", { deep: true })
  updateValidity() {
    if (!this.value.ref) {
      this.$emit("update:isValid", false);
      return;
    }

    const validityList = Object.values(this.validity);
    for (const isValid of validityList) {
      if (!isValid) {
        this.$emit("update:isValid", false);
        return;
      }
    }

    this.$emit("update:isValid", true);
  }

  selectAddress(item: IAddress) {
    this.value.address = item;
  }

  removeRef() {
    this.person = null;
    this.company = null;
    this.value.map(new InvoiceParty());
  }

  onValueFormClick() {
    if (!this.value.ref?.refId) {
      this.open();
    }
  }
}
